export const environment = {
  production: false,
  baseUrl: 'https://api.c5tq2wfczz-wegequipa1-s1-public.model-t.cc.commerce.ondemand.com/',
  googleAnalyticsId: 'GTM-PTVRK5MX',
  googleMapsAPIKey: 'AIzaSyA8KJ2hCvW_FAru_QS0mqcY_wFZVFpDfZs',
  recaptchaKey: '6LcYet0qAAAAAGG7mjvviK7ZjFaIi33E39Zys7IT',
};
